import { useTranslation } from 'react-i18next';

import type { Impact } from './types';

import styles from './Collab.module.css';

/** What an access-changing operation does: shown before it is confirmed ("who gains / loses"). */
export function ImpactSummary({ impact }: { impact: Impact }) {
  const { t } = useTranslation();
  if (impact.gained + impact.lost + impact.changed === 0) {
    return <p className={styles.muted}>{t('collab.impact.none')}</p>;
  }
  return (
    <div className={styles.impact} role="status" data-testid="impact-summary">
      <p className={styles.impactHead}>
        {t('collab.impact.summary', {
          gained: impact.gained,
          lost: impact.lost,
          changed: impact.changed,
        })}
      </p>
      <ul className={styles.impactList}>
        {impact.items.map((item) => (
          <li key={`${item.user_id}-${item.board_id}-${item.change}`}>
            {t(`collab.impact.${item.change}`, {
              user: item.display_name,
              board: item.board_name,
            })}
          </li>
        ))}
      </ul>
      {impact.hidden_boards > 0 && (
        <p className={styles.muted}>{t('collab.impact.hidden', { count: impact.hidden_boards })}</p>
      )}
    </div>
  );
}
